import { createAction } from 'redux-actions';

export const getFullMyClientsRequest = createAction('GET_FULL_MY_CLIENTS_REQUEST');
export const getFullMyClientsAccountsSuccess = createAction('GET_FULL_MY_CLIENTS_SUCCESS');
export const getFullMyClientsAccountsFail = createAction('GET_FULL_MY_CLIENTS_FAIL');

export const updateMyClientsTableSettings = createAction('UPDATE_MY_CLIENTS_TABLE_SETTINGS');
